define((require) => {
    "use strict";

    const _      = require("underscore");
    const Effect = require("shared/ui/experience/action/effects/EffectModel");

    const TYPE = "scale";

    return Effect.extend({
        defaults: _.defaults({
            type: TYPE,
            scale: 1.2
        }, Effect.prototype.defaults)
    }, {
        TYPE
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/effects/ScaleEffectModel.js